// Uses the existing Google & YouTube GA4 destination. Never installs a tag,
// changes consent, replays pre-consent activity, or emits commerce purchases.
const measurementId='G-VLEGB7ZZTM';
const entries=new Set(['homepage_tab','collection_banner','direct']);
const steps=['taste','brew','preferences','results'];
const answers={flavor:['any','comfort','fruity','floral'],method:['any','filter','espresso','immersion'],caffeine:['any','regular','decaf'],body:['any','light','creamy','full'],acidity:['any','balanced','bright','low'],process:['any','washed','natural','honey','experimental']};
export function allowed() {
  try {
    return new URLSearchParams(location.search).get('kaizen_analytics')!=='staff' &&
      sessionStorage.getItem('kaizen:ga4-staff-tab')!=='1' &&
      window['ga-disable-'+measurementId]!==true &&
      window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true && typeof window.gtag==='function';
  } catch {return false;}
}
function context() {const role=window.Shopify?.theme?.role;return window.Shopify?.designMode?'editor':role==='main'?'live':role?'preview':'unknown';}
function send(name,parameters={}) {
  try {
    if(!allowed() || (document.hidden && name!=='coffee_quiz_product_open'))return false;
    const storefront_context=context();
    window.gtag('event',name,{...parameters,storefront_context,send_to:measurementId,...(storefront_context==='live'?{}:{debug_mode:true,traffic_type:'kaizen_preview'})});
    return true;
  } catch {return false;}
}
function choice(question,value) {
  if(question==='budget')return value==null || value==='' || Number(value)===0?'any':Number.isFinite(Number(value)) && Number(value)>0 && Number(value)<=10000?'up_to_'+Number(value):null;
  return answers[question]?.includes(value)?value:null;
}
export function createQuizMeasurement(root) {
  const entry=entries.has(new URLSearchParams(location.search).get('quiz_entry'))?new URLSearchParams(location.search).get('quiz_entry'):'direct';
  let state={},loaded=false,pending=false,action='submit',timer,attempts=0;
  const errors=new Set();
  const cards=new Map();
  let disconnected=false;
  const observer=typeof IntersectionObserver==='function'?new IntersectionObserver(changes=>{
    for(const change of changes){const card=cards.get(change.target);if(card){card.visible=change.isIntersecting && change.intersectionRatio>=0.5;consider(change.target,card);}}
  },{threshold:[0,0.5]}):null;
  function stop(card){clearTimeout(card.timer);card.timer=null;}
  function exposureKey(product,rank) {
    const values=root.answers?.()||{};
    return JSON.stringify([Object.keys(answers).concat('budget').map(q=>choice(q,values[q])||'any'),String(product.id),rank]);
  }
  function consider(node,card) {
    if(disconnected || !node.isConnected || !root.isConnected || root.results?.hidden!==false || !card.visible || document.hidden || !allowed() || getComputedStyle(node).visibility!=='visible'){stop(card);return;}
    if(!load() || state.impressions?.includes(card.key)){stop(card);return;}
    if(card.timer)return;
    card.timer=setTimeout(()=>{card.timer=null;
      if(disconnected || !node.isConnected || !card.visible || root.results?.hidden!==false || document.hidden || !load() || getComputedStyle(node).visibility!=='visible' || state.impressions?.includes(card.key))return;
      const detail=productDetail(card.product,card.variant,card.rank);
      if(detail && event('coffee_quiz_product_impression',detail)){state.impressions=[...(state.impressions||[]),card.key].slice(-1000);persist();}
    },1000);
  }
  function scanProducts() {
    for(const [node,card] of cards){stop(card);observer?.unobserve(node);}
    cards.clear();
    if(disconnected || !observer || root.results?.hidden!==false || !allowed())return;
    for(const node of root.matchContainer?.querySelectorAll('.coffee-finder__match')||[]){
      const rank=(root.rankedMatches?.findIndex(match=>String(match.product.id)===node.dataset.productId)??-1)+1;
      const product=root.rankedMatches?.[rank-1]?.product;
      const variant=node.querySelector('select')?.value;
      if(!product || !productDetail(product,variant,rank))continue;
      const card={product,variant,rank,key:exposureKey(product,rank),visible:false,timer:null};cards.set(node,card);observer.observe(node);
    }
  }
  function load() {
    if(!allowed())return false;
    if(!loaded){const saved=history.state?.coffeeQuizMeasurement;state=saved?.version===1 && saved.path===location.pathname && Date.now()-saved.at<86400000? saved : {version:1,path:location.pathname,at:Date.now(),steps:[],answers:{}};loaded=true;}
    return true;
  }
  function persist() {try{if(allowed())history.replaceState({...history.state,coffeeQuizMeasurement:state},'');}catch{}}
  function event(name,parameters={}) {return send(name,{quiz_entry_point:entry,...parameters});}
  function sync() {
    if(document.hidden || !allowed()){for(const card of cards.values())stop(card);return;}
    if(!load() || !root.isConnected || (root.results?.hidden!==false && root.form?.getAttribute('aria-busy')==='true'))return;
    if(!state.viewed && event('coffee_quiz_view')){state.viewed=true;persist();}
    step(root.results?.hidden===false?3:root.step);
    if(!cards.size)scanProducts();
  }
  function step(index) {
    if(!load() || !steps[index] || state.steps.includes(index))return;
    if(event('coffee_quiz_step',{quiz_step:steps[index]})){state.steps.push(index);persist();}
  }
  function start() {
    if(!load() || state.started)return;
    if(event('coffee_quiz_start',{quiz_step:steps[root.step]||'taste'})){state.started=true;state.startedAt=Date.now();persist();}
  }
  function recordAnswers(values,fields=Object.keys(values)) {
    if(!load())return;
    for(const question of fields){const value=choice(question,values[question]);if(value===null || state.answers[question]===value)continue;
      if(event('coffee_quiz_answer',{quiz_question:question,quiz_answer:value})){state.answers[question]=value;persist();}
    }
  }
  function submit(origin,values) {
    pending=load();action=['submit','update','retry'].includes(origin)?origin:'submit';
    if(!pending)return;
    start();recordAnswers(values);
    event('coffee_quiz_submit',{quiz_action:action});
  }
  function results(count,values) {
    errors.clear();sync();scanProducts();
    if(!pending)return;pending=false;
    if(!load())return;
    const detail={quiz_action:action,quiz_result_state:count?'matches':'no_match',quiz_match_count:Math.max(0,Math.min(10000,count)),quiz_elapsed_seconds:Math.max(0,Math.min(86400,Math.round((Date.now()-(state.startedAt||Date.now()))/1000)))};
    if(!state.completed && event('coffee_quiz_complete',detail)){state.completed=true;persist();}
    event('coffee_quiz_results',detail);
    if(!count)event('coffee_quiz_no_match',detail);
  }
  function error(code,origin='results') {
    if(!['catalog_unavailable','budget_unavailable','popup_blocked','stock_changed'].includes(code))return;
    if(errors.has(code))return;
    if(event('coffee_quiz_error',{quiz_error:code,quiz_action:origin})){errors.add(code);}
    if(code==='catalog_unavailable')pending=false;
  }
  function productDetail(product,variant,rank) {
    const slug=new URL(product.url,location.origin).pathname.split('/').filter(Boolean).at(-1);
    if(!/^[a-z0-9-]{1,100}$/.test(slug||'') || !/^\d+$/.test(String(product.id)) || !/^\d+$/.test(String(variant)) || !Number.isInteger(rank) || rank<1 || rank>10000)return;
    return {quiz_product:slug,item_id:String(product.id),item_variant:String(variant),quiz_result_rank:rank};
  }
  function product(product,variant,rank) {const detail=productDetail(product,variant,rank);if(detail)event('coffee_quiz_product_open',detail);}
  function interact(e) {if(e.isTrusted && root.results?.hidden && e.target.closest('.coffee-finder__choice,coffee-finder-select,[data-next]'))start();}
  root.addEventListener('click',interact,true);
  root.addEventListener('keydown',interact,true);
  const finish=()=>event('coffee_quiz_finish');root.querySelector('.coffee-finder__finish')?.addEventListener('click',finish);
  function consent(){for(const card of cards.values())stop(card);if(!allowed()){pending=false;state={};loaded=false;try{const next={...history.state};delete next.coffeeQuizMeasurement;history.replaceState(next,'');}catch{}}else {sync();scanProducts();}}
  function visibility(){for(const card of cards.values())stop(card);sync();scanProducts();}
  document.addEventListener('visitorConsentCollected',consent);
  document.addEventListener('visibilitychange',visibility);
  timer=setInterval(()=>{sync();if(++attempts>=30){clearInterval(timer);timer=null;}},1000);
  queueMicrotask(sync);
  const api={step,sync,scanProducts,submit,results,error,
    stepComplete(index,values){start();recordAnswers(values,index===0?['flavor']:index===1?['method']:Object.keys(values));event('coffee_quiz_step_complete',{quiz_step:steps[index]});},
    browse(index){event('coffee_quiz_browse',{quiz_result_rank:index+1});},
    edit(){event('coffee_quiz_edit');},
    unavailable(){event('coffee_quiz_unavailable');},
    variant(product,variant){if(/^\d+$/.test(String(product))&&/^\d+$/.test(String(variant)))event('coffee_quiz_variant',{item_id:String(product),item_variant:String(variant)});},
    product,
    disconnect(){disconnected=true;for(const card of cards.values())stop(card);cards.clear();observer?.disconnect();clearInterval(timer);root.removeEventListener('click',interact,true);root.removeEventListener('keydown',interact,true);document.removeEventListener('visitorConsentCollected',consent);document.removeEventListener('visibilitychange',visibility);root.querySelector('.coffee-finder__finish')?.removeEventListener('click',finish);}
  };
  return Object.fromEntries(Object.entries(api).map(([name,method])=>[name,(...args)=>{try{return method(...args);}catch{}}]));
}

// Entry impressions are visible exposure; the marked destination measures
// successful arrivals even if an immediate-navigation click event is lost.
function installEntries() {
  const key=Symbol.for('kaizen.quizEntryMeasurement');if(window[key])return;window[key]=true;
  const targets=new Map();let timer,attempts=0;
  const observer=typeof IntersectionObserver==='function'?new IntersectionObserver(changes=>{for(const e of changes){const s=targets.get(e.target);if(s){s.visible=e.isIntersecting&&e.intersectionRatio>=0.5;consider(e.target,s);}}},{threshold:[0,0.5]}):null;
  function consider(link,s){if(!s.visible||s.seen||!allowed()||document.hidden||getComputedStyle(link).visibility==='hidden'||link.closest('coffee-quiz-shortcut')?.hidden){clearTimeout(s.timer);s.timer=null;return;}if(s.timer)return;s.timer=setTimeout(()=>{s.timer=null;if(s.visible && !s.seen && getComputedStyle(link).visibility!=='hidden' && send('coffee_quiz_entry_view',{quiz_entry_point:s.entry})){s.seen=true;observer?.unobserve(link);}},1000);}
  for(const link of document.querySelectorAll('[data-quiz-entry]')){const entry=link.dataset.quizEntry;if(!entries.has(entry)||entry==='direct')continue;const url=new URL(link.href,location.origin);if(url.origin!==location.origin)continue;url.searchParams.set('quiz_entry',entry);link.href=url.href;
    const s={entry,seen:false,visible:false};targets.set(link,s);observer?.observe(link);
    link.addEventListener('click',e=>{if(e.isTrusted)send('coffee_quiz_entry_click',{quiz_entry_point:entry});});
  }
  document.addEventListener('coffee-quiz-shortcut-dismiss',event=>{
    const tab=event.target;
    if(!tab?.matches?.('coffee-quiz-shortcut') || !tab.hidden)return;
    const link=tab.querySelector('[data-quiz-entry="homepage_tab"]'),s=targets.get(link),action=event.detail?.action;
    if(!s || s.dismissed || !['swipe_left','swipe_right','keyboard_escape'].includes(action))return;
    s.dismissed=true;clearTimeout(s.timer);s.timer=null;observer?.unobserve(link);
    // Intentional interaction proves exposure even before the dwell timer fires.
    if(!s.seen && send('coffee_quiz_entry_view',{quiz_entry_point:s.entry}))s.seen=true;
    send('coffee_quiz_entry_dismiss',{quiz_entry_point:s.entry,quiz_action:action});
  });
  const sync=()=>{for(const [link,s] of targets)consider(link,s);};
  document.addEventListener('visitorConsentCollected',sync);document.addEventListener('visibilitychange',sync);
  if(targets.size)timer=setInterval(()=>{sync();if(++attempts>=30)clearInterval(timer);},1000);
}
if(typeof document!=='undefined'){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',installEntries,{once:true});else installEntries();}
